import React, {useEffect, useState, useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {Menu} from '../../utils/menu/Menu';
import {formatErrors} from '../../constants';
import {toast} from 'react-toastify';
import {SortItem} from '../../utils/sortItem/SortItem';
import {ButtonMore} from '../../utils/buttonMore/buttonMore';
import {ConfirmModal} from '../../utils/confirm/ConfirmModal';
import {dichatGroupsAction, dichatGroupUpdateAction} from '../../actions/dichatGroupAction';
import {DichatGroupModal} from './utils/DichatGroupModal';

/**
 * Болталки канала DiChat.
 *
 * Болталка — групповая комната на несколько клиенток; куратора и поддержки в ней
 * нет по замыслу. Состав правится в карточке клиентки: там видно, где она сейчас
 * и откуда её выводили.
 *
 * Удаление — пометка, а не исчезновение. Комнату в Matrix по-настоящему не
 * удалить, её можно только опустошить: участниц выводят, болталка пропадает у
 * них из списка чатов, а строка остаётся — чтобы болталку можно было вернуть.
 */
const DichatGroups = () => {
  const dispatch = useDispatch();
  const [items, setItems] = useState([]);
  const [withDeleted, setWithDeleted] = useState(false);
  const [loading, setLoading] = useState(false);

  const getList = useCallback(() => {
    dispatch(dichatGroupsAction(withDeleted)).then((data) => {
      setItems(Array.isArray(data) ? data : (data.items || []));
    }).catch(err => {
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, [dispatch, withDeleted]);

  useEffect(() => {
    getList();
  }, [getList]);

  // Удаление и возврат — одна и та же ручка с разным значением пометки
  const handleDeleted = (id, deleted) => {
    return new Promise((resolve, reject) => {
      if (loading) {
        return resolve(false);
      }
      setLoading(true);
      dispatch(dichatGroupUpdateAction(id, {deleted})).then(() => {
        setLoading(false);
        resolve(true);
        toast.success(deleted ? 'Болталка удалена' : 'Болталка возвращена',
          {position: toast.POSITION.BOTTOM_RIGHT});
        getList();
      }).catch(err => {
        setLoading(false);
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        reject(err);
      });
    });
  };

  return <div className="content">
    <Menu isStatic={true}/>

    <div className="heading heading--flex">
      <h2 className="heading__title">Болталки</h2>
      <DichatGroupModal onSuccess={() => getList()} triggerWrap={true}
                        trigger={<button type="button" className="heading__btn heading__btn--invite btn modal-btn">+ Завести</button>}/>
      <button type="button" className="heading__btn btn modal-btn" style={{marginLeft: '10px'}}
              onClick={() => setWithDeleted(value => !value)}>
        {withDeleted ? 'Скрыть удалённые' : 'Показать удалённые'}
      </button>
    </div>
    <div className="users">
      <div className="users__wrapper">
        <div className="sort">
          <SortItem title="Название" className="sort__item--name"/>
          <SortItem title="Участниц" className="sort__item--email"/>
        </div>
        <div className="users__inner">
          {items && items.length > 0 && items.map((i) => <div key={i.id} className="users__item">
            <span className="users__name">
              {i.title}
              {i.deleted && <span className="user-info__status user-info__status--block"
                                  style={{marginLeft: '8px'}}>удалена</span>}
            </span>
            <span className="users__email">{i.members}</span>
            <ButtonMore>
              <ul className="dropdown">
                <li>
                  <DichatGroupModal item={i} triggerWrap={false} onSuccess={() => getList()}
                                    trigger={<div className="dropdown__item icon-edit">Переименовать</div>}/>
                </li>
                {!i.deleted && <li>
                  <ConfirmModal trigger={<div className="dropdown__item icon-delete">Удалить</div>} triggerWrap={false}
                                title={"Удалить болталку? Все участницы будут из неё выведены."}
                                handleOk={() => handleDeleted(i.id, true)}/>
                </li>}
                {i.deleted && <li>
                  <ConfirmModal trigger={<div className="dropdown__item icon-mark">Вернуть</div>} triggerWrap={false}
                                title={"Вернуть болталку? Участниц надо будет добавить заново."}
                                handleOk={() => handleDeleted(i.id, false)}/>
                </li>}
              </ul>
            </ButtonMore>
          </div>)}
          {(!items || items.length === 0) && <div className="users__item">
            <span className="users__name">Болталок пока нет</span>
          </div>}
        </div>
      </div>
    </div>
  </div>;
};

export default DichatGroups;
